module.exports = __webpack_public_path__ + "img/sun-border.925566d7.svg";